import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useSelector, useDispatch } from 'react-redux';
import { setGetUserById } from '../../store/thunk/setGetUserById';
import { useRouter } from '../../../../../@casino/useRouter';
import { setGetJackpotHistoryList } from '../../store/thunk/setGetJackpotHistoryList';
import JackpotItem from '../../components/jackpotItem';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import Navigation from '../../components/navigation';
import moment from 'moment';

const handleLoadPagination = ({page, setPage, countPage, dispatch, search, date_from, date_to}) => {
    if (page <= countPage) {
        dispatch(setGetJackpotHistoryList({
            page: page + 1,
            rowsPerPage: 10,
            search,
            date_from,
            date_to
        }));
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const Jackpot = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const utc = moment.utc().valueOf();
    const currentDate = utc;

    const {id} = router.query;

    const [page, setPage] = React.useState(1);
    const [isShowNavigation, setIsShowNavigation] = React.useState(false);

    React.useEffect(() => {
        dispatch(setGetUserById(id));
    }, [id])

    const view = useSelector(state => state.usersMobile.view);

    React.useEffect(() => {
        if (view?.login) {
            dispatch(setGetJackpotHistoryList({
                page: 1,
                rowsPerPage: 10,
                search: view?.login,
                date_from: 0,
                date_to: currentDate
            }))
        }
        // eslint-disable-next-line
    }, [view.login, currentDate])

    const list = useSelector(state => state.usersMobile.list_jackpot);
    
    if (view && view.login) {
        return (
            <TemplatePage
                title={`Джекпоты (${view.login ? view.login : ''})`}
                pagination={page < list.countPage && list.data.length}
                handleLoadPagination={() => handleLoadPagination({
                    page,
                    setPage,
                    countPage: list.countPage,
                    dispatch,
                    search: view.login,
                    date_from: 0,
                    date_to: currentDate
                })}
                handleLoading={() => handleLoading(dispatch)}
            >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', columnGap: 10}}>
                    <span 
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                            border: '1px solid #ffce01',
                            cursor: 'pointer',
                            outline: 'none',
                            padding: '5px 0',
                            background: '#ffce01',
                            borderRadius: '12px',
                            color: '#24263e',
                            fontSize: 14,
                            fontWeight: 700
                        }}
                        onClick={() => {
                            setIsShowNavigation(true)
                        }}
                    >Дополнительно</span>
                </div>
                {
                    list.data.map((item) => <JackpotItem item={item} />)
                }
                <Navigation isShowNavigation={isShowNavigation} setIsShowNavigation={setIsShowNavigation} id={id}  profile={view}/>
            </TemplatePage>
        )
    } else {
        return <>loading</>
    }
    
}

export default Jackpot;